import { Injectable } from '@angular/core';
import {
    FilterParams,
    FilterResult,
    RepositoryService,
} from '../../../helpers/crud/repository.service';
import { HasId } from '../../../helpers/crud/edit/HasId';
import { WancomHttpService } from '../../../services/wancom-http/wancom-http.service';
import { WaitingService } from '../../layout/waiting/waiting.service';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ActivityService extends RepositoryService<Activity> {
    constructor(http: WancomHttpService, waiting$: WaitingService) {
        super(http, waiting$, 'activities');
    }

    /**
     *
     * @param filterParams
     * @returns `FilterResult<ActivityCategory>` Liste des activités groupées par catégories
     */
    getActivityCategories(filterParams: ActivityFilterParams) {
        return this.http.post<FilterResult<ActivityCategory>>(
            this.url,
            filterParams,
            environment.apiBaseStore
        );
    }
}

export class ActivityFilterParams extends FilterParams {
    name?: string;
}

export class Activity implements HasId {
    id: number;
    name: string;
}

/**
 * Catégorie d'activité
 */
export interface ActivityCategory {
    /**
     * Id de la catégorie de l'activité
     */
    id: number;
    /**
     * Nom de la catégorie de l'activité
     */
    name: string;
    /**
     * Liste des activités de la catégorie
     */
    activities: Activity[];
}
